<template>
  <div class="form-wrapper">
    <el-form :model="ruleform" class="popup" :rules="rules" ref="ruleform">
      <zj-layout-container class="header">
        <zj-layout-header>
          <div class="listtitle">任务反馈</div>
        </zj-layout-header>
      </zj-layout-container>
      <zj-layout-container class="content">
        <el-form-item label="任务名称" prop="taskName">
          <el-input v-model="ruleform.taskName" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="负责人" prop="personIdTranslated">
          <el-input v-model="ruleform.personIdTranslated" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="mobileNo">
          <el-input v-model="ruleform.mobileNo" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="任务响应时间" prop="responseMinute">
          <el-input v-model="ruleform.responseMinute" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="执行状态" prop="status">
          <el-radio-group v-model="ruleform.status" @change="execStatusChanged">
            <!-- <el-radio label="2">已完成</el-radio>
            <el-radio label="1">未完成</el-radio>
            <el-radio label="4">任务关闭</el-radio> -->
            <el-radio v-for="(item, index) in options" :key="index" :label="item.code">{{item.value}}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="备注" prop="content">
          <el-input type="textarea" v-model="ruleform.content"></el-input>
        </el-form-item>
        <el-form-item class="btns">
          <el-button @click="onBack()">返回</el-button>
          <el-button type="primary" @click="submitForm('ruleform')">提交</el-button>
        </el-form-item>
      </zj-layout-container>
    </el-form>
  </div>
</template>
<script>
import ZJApp from "../../../../../../app";
// eslint-disable-next-line no-unused-vars
import { getDictionary } from "@/api/src/emergency_common";
import { save } from "@/api/src/emergency_feedback";
import { update } from "@/api/src/emergency_command_task";

export default {
  name: "ZJEmergencyComponentTaskFeedback",
  componentName: "ZJEmergencyComponentTaskFeedback",
  components: {},
  props: {
    currentTask: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      // eslint-disable-next-line no-undef
      ruleform: $.extend(
        {},
        { status: "", content: "" },
        this.currentTask
      ),
      rules: {
        status: [
          { required: true, message: "请选择执行状态", trigger: "blur" },
        ],
        content: [
          { required: true, message: "请填写反馈内容", trigger: "blur" },
          { min: 0, max: 500, message: "长度最长为500个字符", trigger: "blur" },
        ],
      },
      msgkey: {
        emergencyFeedbackKey:
          "MessageKey_EmergencyFeedBack" + this.currentTask.eventId,
        emergencyFinishTaskKey:
          "MessageKey_EmergencyFinishTask" + this.currentTask.eventId,
      },
      options: [],
    };
  },
  created(){
    getDictionary('emergency_command_status').then(r =>{
      this.options = r.data.records
    })
  },
  methods: {
    submitForm(formName) {
      let that = this;
      this.$refs[formName].validate().then((valid) => {
        if (valid) {
          //插入反馈数据
          save(that.feedback)
            .then((r) => {
              let code = r.code;
              if (code == 0) {
                //增加反馈成功，发送反馈成功消息
                that.$notify.broadcase({
                  key: that.msgkey.emergencyFeedbackKey,
                  data: that.feedback,
                });

                //更新任务状态
                let { id, status }= this.currentTask
                update({ id, status })
                  .then((r) => {
                    let code = r.code;
                    if (code == 0) {
                      //发送任务完成消息
                      console.log(
                        "broadcase : " + that.msgkey.emergencyFinishTaskKey
                      );
                      that.$notify.broadcase({
                        key: that.msgkey.emergencyFinishTaskKey,
                        data: that.currentTask,
                      });

                      that.$message({
                        message: "反馈任务成功！",
                        type: "success",
                      });
                      //关闭当前弹窗
                      that.$emit("handlerclose");
                    }
                  })
                  .catch((e) => {
                    console.error(e);
                  });
              }
            })
            .catch((e) => {
              console.error(e);
            });
        }
      });
    },
    onBack: function () {
      this.$emit("handlerclose");
    },
    execStatusChanged: function (value) {
      this.currentTask.status = value;
    },
  },
  computed: {
    feedback: function () {
      var feedback = {
        createUser: ZJApp.ZJUser.current.UserName,
        content: this.ruleform.content,
        status: this.ruleform.status,
        taskId: this.ruleform.id,
        eventId: this.ruleform.eventId,
        feedbackType:2, //反馈类型(1-现场反馈2-任务执行3启动应急预案)
      };
      return feedback;
    },
  },
  watch: {
    currentTask: {
      // eslint-disable-next-line no-unused-vars
      handler: function (val, oldVal) {
        // eslint-disable-next-line no-undef
        this.ruleform = $.extend(
          {},
          { status: "", content: "" },
          this.currentTask
        );
      },
      immediate: true,
      deep: true,
    },
  },
};
</script>